import API from '~/services/api'
import { swymFetch } from '~/services/fetch-swym'

import type { IWedo } from '~/entities/content/wedo/interfaces/wedo'

import type { IExaleadParams } from '~/features-shared/content/api/interfaces/params'
import { ORDERBY, ORDERFIELD } from '~/features-shared/content/api/interfaces/params'
import { contentsParser } from '~/features-shared/content/api/parser-exalead'
import { IContentModel } from '~/features-shared/content/interfaces/content-model'
import { WedoDS6WMaturity } from '~/features-shared/maturities/interfaces/exalead-maturities'
import { WedoMaturity } from '~/features-shared/maturities/interfaces/maturities'

import type { ExaleadService } from '~/interfaces/crud-service'
import type { ExaleadResponse } from '~/interfaces/services-dto'

export function toDS6WMaturity(maturity: WedoMaturity) {
  const maturities = {
    [WedoMaturity.Open]: WedoDS6WMaturity.Open,
    [WedoMaturity.InProgress]: WedoDS6WMaturity.InProgress,
    [WedoMaturity.Done]: WedoDS6WMaturity.Done,
  }

  return maturities[maturity]
}

export function toMaturity(maturity: WedoDS6WMaturity) {
  const maturities = {
    [WedoDS6WMaturity.Open]: WedoMaturity.Open,
    [WedoDS6WMaturity.InProgress]: WedoMaturity.InProgress,
    [WedoDS6WMaturity.Done]: WedoMaturity.Done,
  }

  return maturities[maturity]
}

// TODO: Refractor with IQuestions
export const WedosService: ExaleadService<IWedo> = {
  async count(params) {
    const response: ExaleadResponse = await swymFetch
      .post(API.Wedo.Exalead.Content, {
        json: {
          params: {
            legacyFormat: false,
            contentType: IContentModel.Wedo,
            query: '#all',
            with_synthesis: false,
            start: 0,
            nresults: 0,
            ...params,
          } as IExaleadParams,
        },
      })
      .json()

    return {
      data: [],
      total: response.nhits,
    }
  },
  async getAll(params) {
    const legacyFormat = false
    const order_by = ORDERBY.DESC
    const nresults = 15

    const response = await swymFetch
      .post(API.Wedo.Exalead.Content, {
        json: {
          params: {
            legacyFormat,
            nresults,
            order_by,
            order_field: ORDERFIELD.UPDATE,
            query: '#all',
            start: 0,
            with_synthesis: true,
            contentType: IContentModel.Wedo,
            ...params,
          } as IExaleadParams,
        },
      })
      .json<ExaleadResponse>()

    return {
      total: response.nhits,
      data: contentsParser(response) as IWedo[],
    }
  },
}
